export default __webpack_public_path__ + "static/media/home_delete_icon.90350fe5.svg";